import { render, staticRenderFns } from "./dispatch_board_tbn.vue?vue&type=template&id=dfa8e914&scoped=true&"
import script from "./dispatch_board_tbn.vue?vue&type=script&lang=js&"
export * from "./dispatch_board_tbn.vue?vue&type=script&lang=js&"
import style0 from "./dispatch_board_tbn.vue?vue&type=style&index=0&id=dfa8e914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa8e914",
  null
  
)

export default component.exports